import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { ReportTypeModel, CollectionIssueTypeCategoryModel } from "./models";
import { SuburbAndStreetsModel, WasteStreamModel } from "@/api/Shared";

export interface LetterTemplateSummaryModel {
  letterTemplateId: number;
  letterTemplateName: string;
}

export type GetReportsRequest = {};

export type GetReportsResponse = {
  reportTypes: ReportTypeModel[];
  wasteStreams: WasteStreamModel[];
  suburbsAndStreetNames: SuburbAndStreetsModel[];
  collectionIssueTypeCategories: CollectionIssueTypeCategoryModel[];
  letterTemplates: LetterTemplateSummaryModel[];
};

export const getReports = async () => {
  const response = await executeApiRequest(() => axios.get<GetReportsResponse>("/reports"));
  return response?.data;
};
